export default "__VITE_ASSET__Cyf3HDyw__"